<template>
  <landing-page
    label="patients.patients"
    description="patients.patientsDesc"
    labelColor="#488F82"
    descColor="#488F82"
    :eggImgObj="{ componentName: 'patients', imgName: 'patientsIntro', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconGreenRight', imgFormat: 'svg' }"
    class="mb-10"
  />

  <!--<TitleWStar title="patients.patients" 
  titleColor="sea-blue" 
  :starIconObj="{ componentName: 'shared', imgName: 'starIconLightBlue', imgFormat: 'svg' }" 
  />
  change obj to constant?-->
</template>

<script setup lang="ts">
import { usePatientsStore } from "@/stores/patients";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const patientsStore = usePatientsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>